import { Icon } from "@elit-hair/elit-ui";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { TbCalendarEvent } from "react-icons/tb";

import { CalendarCapacitiesWidget } from "@/pages/home/components/dashboard/calendar-capacities-widget";
import { APP_ROUTES_FULL, APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_FULL.PERFORMANCE_CALENDAR_CAPACITIES)({
    component: PerformanceCalendarCapacitiesPage,
    staticData: {
        config: {
            breadcrumb: {
                title: "calendar_capacities_title",
                to: APP_ROUTES_TO.PERFORMANCE_CALENDAR_CAPACITIES,
            },
            sidebar: {
                label: "calendar_capacities_title",
                icon: TbCalendarEvent,
            },
            title: "calendar_capacities_title",
        },
    },
});

function PerformanceCalendarCapacitiesPage() {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col gap-4 p-4 h-full w-full overflow-auto">
            <div className="flex flex-col gap-4 max-w-5xl mx-auto w-full">
                <div className="flex items-center gap-2">
                    <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary/10">
                        <Icon icon={TbCalendarEvent} size={18} className="text-primary" />
                    </div>
                    <div>
                        <h1 className="text-xl font-bold">{t("calendar_capacities_title")}</h1>
                        <p className="text-xs text-muted-foreground">{t("calendar_capacities_subtitle")}</p>
                    </div>
                </div>
            </div>

            <div className="max-w-5xl mx-auto w-full">
                <CalendarCapacitiesWidget hideHeader />
            </div>
        </div>
    );
}
